import React from 'react';

function HelpModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        
        
  <h2 id="help-title">How to Play</h2>
  <p>You have <strong>6 attempts</strong> to find the 5-digit code.</p>

  <p>Pick 5 digits, a digit can appear twice at most.</p>
  <p>After each guess You get hints on the right code</p>
    <h4><strong>Goal:</strong></h4>
    <p> Is the real result greater or smaller than the outcome of the guess evaluation.</p>
    <h4>Digit hints:</h4>
    <ul>      
        <li><strong>Green:</strong> The digit is correct and is located at the right spot</li>
        <br></br>
        <li><strong>Yellow</strong>The digit is correct but is not located at the right spot.\n</li>
        <br></br>
        <li><strong>Grey:</strong>this digit is not part of the code.</li>      
    </ul>
    
    
  <h4>Good luck</h4>
  <h3>"  "</h3>

  
  
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default HelpModal;
